import gsap from "gsap";
import { trackEvent } from "../utils/matomo";
export default function Heroblock() {
  Alpine.data("heroblock", () => ({
    init() {
      gsap.matchMedia().add("(min-width: 1024px)", () => {
        this.animate();
      });
    },
    share() {
      const url = this.$el.dataset.url;
      const title = this.$el.dataset.title;
      trackEvent("Share", "Share Game", title);
      if (navigator.share) {
        navigator
          .share({
            title: title,
            url: url,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      } else {
        // fallback for browsers that do not support the Web Share API
        alert(
          "Sharing is not supported in this browser. Please copy the URL manually.",
        );
      }
    },
    animate() {
      const media = this.$refs.media;
      const content = this.$refs.content;
      if (!media || !content || !media.children[0] || !media.children[1])
        return;

      const tl = gsap.timeline({ delay: 0.25 });

      // Overlay wipes out, revealing the image beneath
      tl.fromTo(
        media.children[0],
        { xPercent: 0 },
        { xPercent: -100, ease: "power4.out", duration: 0.9 },
      );

      // Image slides into position, offset slightly behind the overlay
      tl.fromTo(
        media.children[1],
        { xPercent: 8 },
        { xPercent: 0, ease: "power4.out", duration: 0.9 },
        "<0.1",
      );

      // Content fades in after the reveal settles
      tl.fromTo(
        content,
        { opacity: 0 },
        { opacity: 1, ease: "power4.out", duration: 0.9 },
        "-=0.9",
      );
    },
  }));
}
